import React from 'react'
import styled from 'react-emotion'

import Panel from '../../components/Panel'
import { Container } from '../../components/Bootstrap'
import MandatePages from '../../components/Mandate'

const FlexWrapper = styled('div')`
	display: flex;
	justify-content: center;
`

const FlexInner = styled('div')`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
`

const Mandate = () => (
  <>
	<Panel colour="#ffffff">
		<h2>Confirmed Mandate</h2>
		<Container>
			<MandatePages />
		</Container>
	</Panel>
	<Panel colour="#ffffff">
		<FlexWrapper>
			<svg style={{ marginRight: '2rem' }} width="675" height="530" viewBox="0 0 675 530" fill="none" xmlns="http://www.w3.org/2000/svg">
				<circle cx="261" cy="261" r="260.5" fill="#013B5A" stroke="#fff" />
				<circle cx="260.5" cy="261.5" r="175" fill="#03527D" stroke="#fff" strokeWidth="5" />
				<circle cx="260.5" cy="261.5" r="87" fill="#FFE7AE" stroke="#fff" strokeWidth="5" />
				<line x1="270.723" y1="243.974" x2="566.723" y2="50.974" stroke="#FFE7AE" strokeWidth="12" />
				<line x1="364" y1="264" x2="636" y2="264" stroke="#03527D" strokeWidth="12" />
				<line x1="436.283" y1="385.978" x2="589.283" y2="485.978" stroke="#013B5A" strokeWidth="12" />
				<circle cx="578" cy="45" r="39" fill="#FFE7AE" />
				<circle cx="636" cy="265" r="39" fill="#03527D" />
				<circle cx="586" cy="491" r="39" fill="#013B5A" />
			</svg>
			<FlexInner>
				<p>
					Step 1<br />
					<strong>Empower consumers</strong>
				</p>
				<p>
					Step 2<br />
					<strong>Enhance strategic partnerships</strong>
				</p>
				<p style={{ marginBottom: 0 }}>
					Step 3<br />
					<strong>Leverage evidence based research and participatory action</strong>
				</p>
			</FlexInner>
		</FlexWrapper>
	</Panel>
  </>
)

export default Mandate
